import { useEventListener } from '@vueuse/core';

const useInfiniteScroll = (callback: () => void, targetElement?: HTMLElement) => {
  const handleScroll = () => {
    if (targetElement) {
      if (targetElement.scrollTop + 2 >= targetElement.scrollHeight - targetElement.offsetHeight) {
        callback();
      }
      return;
    }
    const targetPosition = document.documentElement.offsetHeight - window.innerHeight;
    const bottomPosition = document.documentElement.scrollTop + window.innerHeight;

    if (bottomPosition >= targetPosition) {
      callback();
    }
  };
  useEventListener(targetElement ?? window, 'scroll', handleScroll);

  return {
    triggerIfAtEnd: handleScroll,
  };
};

export default useInfiniteScroll;
